import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';

export default function BrowseButton({
  className,
  location,
  block,
  btnText,
  bundles,
  size,
  outline,
}) {
  return (
    <Button
      outline={outline}
      block={block}
      color="primary"
      size={size}
      className={className}
      tag={Link}
      to={`/${location}`}
    >
      {btnText && !bundles &&
        <span>
          {btnText}
        </span>
      }
      {bundles &&
        <FormattedMessage id="browsebutton.viewallbundle" defaultMessage="View All Bundles" />
      }
      {!bundles && !btnText &&
        <FormattedMessage id="browsebutton.viewall" defaultMessage="View All" />
      }
    </Button>
  );
}

BrowseButton.propTypes = {
  className: PropTypes.string,
  location: PropTypes.string,
  block: PropTypes.bool,
  bundles: PropTypes.bool,
  outline: PropTypes.bool,
  btnText: PropTypes.string,
  size: PropTypes.string,
};

BrowseButton.defaultProps = {
  className: '',
  location: '',
  block: false,
  bundles: false,
  outline: true,
  btnText: null,
  size: 'sm',
};
